/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthSelectionRelationType = {
    ExternalEmrDocument: 'EXTERNAL_EMR_DOCUMENT',
    ScreenerGeneratedDocument: 'SCREENER_GENERATED_DOCUMENT',
    PalReauthAdditionalDocument: 'PAL_REAUTH_ADDITIONAL_DOCUMENT',
} as const;
export type PalReauthSelectionRelationType = typeof PalReauthSelectionRelationType[keyof typeof PalReauthSelectionRelationType];


export function instanceOfPalReauthSelectionRelationType(value: any): boolean {
    for (const key in PalReauthSelectionRelationType) {
        if (Object.prototype.hasOwnProperty.call(PalReauthSelectionRelationType, key)) {
            if (PalReauthSelectionRelationType[key as keyof typeof PalReauthSelectionRelationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalReauthSelectionRelationTypeFromJSON(json: any): PalReauthSelectionRelationType {
    return PalReauthSelectionRelationTypeFromJSONTyped(json, false);
}

export function PalReauthSelectionRelationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSelectionRelationType {
    return json as PalReauthSelectionRelationType;
}

export function PalReauthSelectionRelationTypeToJSON(value?: PalReauthSelectionRelationType | null): any {
    return value as any;
}

export function PalReauthSelectionRelationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PalReauthSelectionRelationType {
    return value as PalReauthSelectionRelationType;
}

